var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-data-table',{attrs:{"p-headers":_vm.headers,"p-title":"Mesas","p-read-link":"table.read.one","p-create-link":"table.create","p-name":"tables"}})}
var staticRenderFns = []

export { render, staticRenderFns }